import { render } from "./NewTeam.vue?vue&type=template&id=e7054bd0"
import script from "./NewTeam.vue?vue&type=script&lang=js"
export * from "./NewTeam.vue?vue&type=script&lang=js"

import exportComponent from "/home/milu/Projects/tesco-csapatnap/csapatnap.hu-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__